import React from 'react'
import './whatYellow.css'
import Feature from '../../components/feature/Feature'

const WhatYellow = () => {
  return(
    <div className='yellow__whatYellow section__margin' id='wjs'>
      <div className='yellow__whatYellow-feature'>
        <Feature title='What is yellow' text='The imperative for data-driven recycling and waste management technology is clear. By addressing inefficiencies, enhancing recycling rates, and empowering communities, we pave the way for a more sustainable and resilient future. Our commitment to innovation and social impact positions us at the forefront of the waste management industry, driving positive change and fostering sustainable communities globally.'/>

      </div>
      <div className='yellow__whatYellow-heading'>
        <h1 className='gradient__text'>ReImagine circulatity to deliver social and environmental impact</h1>
        <p>Explore The Library</p>
      </div>
      <div className='yellow__whatYellow-container'>
        <Feature title='Optimized Routes' text=' Our mission is to transform this landscape by introducing optimized routes for waste collection and recycling delivery, leveraging data-driven technology to create a more sustainable and efficient system.'/>
        <Feature title='Data Reporting' text='Continuously analyze data from satellite imagery, sensors, and other sources to provide actionable insights and recommendations for improvement.'/>
        <Feature title='Cashless payments' text='Cashless payments for on-platform  transactions.Provide loyalty rewards and special promotions for long-term customers'/>
      </div>
    </div>
  )
}

export default WhatYellow